import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import ProductIcon from '../icons/ProductIcon';
interface Props {
  imageUrl: string | null;
  productName: string;
  isOutOfStock?: boolean;
  imageClassName?: string;
  fallbackClassName?: string;
  outOfStockImageClassName?: string;
  position?: number;
}
const ProductListingImage = ({
  imageUrl,
  productName,
  isOutOfStock = false,
  imageClassName,
  outOfStockImageClassName,
  fallbackClassName = 'h-16 w-16',
  position
}: Props) => {
  const {
    t
  } = useTranslation('products');
  const isPriority = position !== undefined && position < 6;
  return <div className={`aspect-square p-2 shrink-0 grow-0 relative flex items-center justify-center pb-1 ${imageClassName}`} data-sentry-component="ProductListingImage" data-sentry-source-file="ProductListingImage.tsx">
      {imageUrl ? <Image src={imageUrl} alt={productName} width={80} height={80} className={`object-contain ${isOutOfStock && 'opacity-50'}`} style={{
      width: 'auto',
      height: '100%'
    }} priority={isPriority} loading={isPriority ? 'eager' : 'lazy'} sizes="(max-width: 640px) 50vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 20vw" quality={85} placeholder="blur" blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjE0NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTI4IiBoZWlnaHQ9IjE0NCIgZmlsbD0iI2YzZjRmNiIvPjwvc3ZnPg==" /> : <ProductIcon className={fallbackClassName} />}
      {isOutOfStock && <div className={`absolute text-[10px] bg-opacity-75 flex items-center justify-center left-0 top-2 ${outOfStockImageClassName}`} style={{
      willChange: 'transform'
    }}>
          <span className="bg-[#5A6066] py-1 px-4 rounded-2xl text-white text-center">
            {t('out_of_stock')}
          </span>
        </div>}
    </div>;
};
export default memo(ProductListingImage);